import React from 'react';
import logo from '../assets/logo.png';

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg fixed-top shadow-sm">
      <div className="container-lg">
        <a className="brand-logo d-flex align-items-center text-decoration-none" href="#">
          <img src={logo} alt="FastInQueue Logo" style={{ height: '40px', width: 'auto', marginRight: '8px' }} />
          <span className="fw-bold fs-4 text-primary-custom" style={{ letterSpacing: '0px' }}>FastInQueue</span>
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav mx-auto">
            <li className="nav-item">
              <a className="nav-link" href="#home">Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#features">Features</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#application">Application</a>
            </li>
          </ul>
          <div className="d-flex d-none">
            On board with FastInQueue
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
